export default {
  methods: {
    downloadFile (data, fileName) {
      const fileType = data.headers['content-type'] || 'text/plain'
      const file = new Blob([data.data], { type: fileType })
      const filename = fileName // 'tv_uredjaj_uputstvo.pdf'

      if (window.navigator.msSaveOrOpenBlob) { // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename)
      } else { // Others
        const link = document.createElement('a')
        const url = URL.createObjectURL(file)
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        setTimeout(function () {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 0)
      }
    }
  }
}
